"use client";

import React from "react";
import { defaultTheme } from "@/src/config/colors";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "primary" | "success" | "warning" | "danger" | "info";
  size?: "sm" | "md";
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
}) => {
  const variants = {
    primary: {
      bg: defaultTheme.primary,
      text: defaultTheme.text.primary,
    },
    success: {
      bg: defaultTheme.success,
      text: defaultTheme.text.inverse,
    },
    warning: {
      bg: "#FFA500",
      text: defaultTheme.text.inverse,
    },
    danger: {
      bg: defaultTheme.accent,
      text: defaultTheme.text.inverse,
    },
    info: {
      bg: defaultTheme.surface,
      text: defaultTheme.text.primary,
    },
  };

  const sizes = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
  };

  const variantStyles = variants[variant];

  return (
    <span
      className={`inline-flex items-center justify-center font-medium rounded-full ${sizes[size]} ${className}`}
      style={{
        backgroundColor: variantStyles.bg,
        color: variantStyles.text,
      }}
    >
      {children}
    </span>
  );
};
